import { useCallback, useState } from 'react';

import type { PaginatedRequestQuery } from '../../../../shared/types/routes/pagination';

import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from './consts';

type PaginationState = Required<PaginatedRequestQuery> & {
  setPage: (page: number) => void;
  setPageSize: (pageSize: number) => void;
  /**
   * @deprecated Use `pageSize` instead.
   */
  count: number;
  /**
   * @deprecated Use `setPageSize` instead.
   */
  setCount: (count: number) => void;
};

/**
 * A very basic hook for setting up the pagination state.
 */
const usePaginationState = (
  initialPage: number = DEFAULT_PAGE,
  initialPageSize: number = DEFAULT_PAGE_SIZE,
): PaginationState => {
  const [page, setPage] = useState<number>(initialPage);
  const [pageSize, setPageSizeState] = useState<number>(initialPageSize);

  const setPageSize = useCallback((newPageSize: number) => {
    setPageSizeState(newPageSize);
    setPage(DEFAULT_PAGE);
  }, [setPage, setPageSizeState]);

  return {
    page,
    setPage,
    pageSize,
    setPageSize,
    //  @deprecated - Legacy, use `pageSize` instead.
    count: pageSize,
    //  @deprecated - Legacy, use `setPageSize` instead.
    setCount: setPageSize,
  };
};

export default usePaginationState;
